/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { LoadCarrierOrder } from '../../models/load-carrier-order';

export interface PutLoadCarrierOrder$Params {
  organizationKey: KeyType;
      body: LoadCarrierOrder
}

export function putLoadCarrierOrder(http: HttpClient, rootUrl: string, params: PutLoadCarrierOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadCarrierOrder>> {
  const rb = new RequestBuilder(rootUrl, putLoadCarrierOrder.PATH, 'put');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoadCarrierOrder>;
    })
  );
}

putLoadCarrierOrder.PATH = '/organizations/{organizationKey}/load-carrier-order';
